import React from "react";
import Card from "components/card/Card";
import Table from 'components/table/Table';
import { userFields } from '../../../models/data';

export default function UserTable({
    isLoading = false, reportDate = null, filter = false, setReportDate = null, setFilterState = null, addControl, deleteFn, editFn, data = []
}) {

    const tableProps = {
        ...userFields,
        data,
        useBasicTemplate: false,
        toolbarIsVisible: true,
        pagingIsAllowed: true,
        fontSize: 13,
        pageSize: 10,
        loading: isLoading,
        disableAdd: false,
        addControl,
        addToolTip: '',
        filename: 'Users',
        disableDelete: false,
        disableEdit: false,
        actionsPosition: 0,
        deleteFn,
        editFn
    }

    return (
        <Card
            w='100%'
            px='15px'
            py='15px'
            overflowX={{ sm: "scroll", lg: "hidden" }}>
            <Table {...tableProps} />
        </Card>
    );
}
